<template>
  <div>
    <Traffic-Map />
    <Traffic-Table />
  </div>
</template>

<script>
import TrafficMap from '@/views/traffic/sub/TrafficMap.vue'
import TrafficTable from '@/views/traffic/sub/TrafficTable.vue'

export default {
  components: {
    TrafficMap,
    TrafficTable,
  },
}
</script>

<style>

</style>
